import { render, staticRenderFns } from "./tabFinanceCapitalIncomeRecordFromDonation.vue?vue&type=template&id=0d9e294e&"
import script from "./tabFinanceCapitalIncomeRecordFromDonation.vue?vue&type=script&lang=ts&"
export * from "./tabFinanceCapitalIncomeRecordFromDonation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports